import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { LoggingService } from 'src/app/services/logging.service';
import { PHBHPLayoutPackageService } from './ph-bhp-layout-package.service';

@Injectable({
  providedIn: 'root'
})
export class PHBHPApiService {
  expandedMenu = false;
  authHeaderOptions: any;
  Interval;
  constructor(private http: HttpClient, public layoutService: PHBHPLayoutPackageService, public translate: TranslateService, private logging: LoggingService) { }

  setHeader(isAuth: boolean) {
    this.layoutService.setActionDate();
    var headers: any = {}
    if (isAuth) {
      headers.Authorization = "Bearer " + window.localStorage.getItem('access_token');
    }
    headers['Content-Type'] = 'application/json';
    this.setCacheControlProperties(headers);
    this.authHeaderOptions = { headers: new HttpHeaders(headers) };
    //,withCredentials: true
  }

  setFileHeader(isAuth: boolean) {
    this.layoutService.setActionDate();
    var headers: any = {}
    if (isAuth) {
      headers.Authorization = "Bearer " + window.localStorage.getItem('access_token');
    }
    //headers['Content-Type'] = 'multipart/form-data';
    headers['Accept'] = 'application/json';
    this.setCacheControlProperties(headers);
    this.authHeaderOptions = { headers: new HttpHeaders(headers) };
    //,withCredentials: true
  }

  setCacheControlProperties(headers) {
    headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    headers['Pragma'] = 'no-cache';
    headers['Pragma-Directive'] = 'no-cache';
    headers['Cache-Directive'] = 'no-cache';
    headers['max-age'] = 0;
    headers['expires'] = 0;
  }

  postApi(url: string, postValue: any, isAuth: boolean) {
    this.setHeader(isAuth);
    return this.http.post(this.layoutService.apiUrl + url, postValue, this.authHeaderOptions).pipe(
      map(res => { return res; }),
      //tap(res=>{ return res;}),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }

  putApi(url: string, putValue: any, isAuth: boolean) {
    this.setHeader(isAuth);
    return this.http.put(this.layoutService.apiUrl + url, putValue, this.authHeaderOptions).pipe(
      map(res => { return res; }),
      //tap(res=>{ return res;}),
      catchError(err => { this.catchError(err); return of(err.message) })
    );

  }

  patchApi(url: string, patchValue: any, isAuth: boolean) {
    this.setHeader(isAuth);
    return this.http.patch(this.layoutService.apiUrl + url, patchValue, this.authHeaderOptions).pipe(
      map(res => { return res; }),
      //tap(res=>{ return res;}),
      catchError(err => { this.catchError(err); return of(err.message) })
    );

  }

  getApi(url: string, isAuth: boolean) {
    this.setHeader(isAuth);
    return this.http.get(this.layoutService.apiUrl + url, this.authHeaderOptions).pipe(
      map(res => { return res; }),
      //tap(res=>{ return res;}),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }

  deleteApi(url: string, isAuth: boolean) {
    this.setHeader(isAuth);
    return this.http.delete(this.layoutService.apiUrl + url, this.authHeaderOptions).pipe(
      map(res => { return res; }),
      //tap(res=>{ return res;}),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }

  catchError(err: Error) {
    this.layoutService.showLoader = false;
    // var data = err.error;
    // if(err.status == 401){
    //   window.localStorage.removeItem('access_token');
    //   this.router.navigateByUrl("/login");
    // } else if(data && data.message){
    //   this.data.showError(this.layoutService.translateText(data.message));
    // } else {
    //   this.data.showError(this.layoutService.translateText(this.translationKeys.ErrorMessages.SomethingWentWrong));
    // }
    throw err
  }

  postFileApi(url: string, postValue: any, isAuth: boolean) {
    this.setFileHeader(isAuth);
    return this.http.post(this.layoutService.apiUrl + url, postValue, this.authHeaderOptions).pipe(
      map(res => { return res; }),
      //tap(res=>{ return res;}),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }

  putFileApi(url: string, putValue: any, isAuth: boolean) {
    this.setFileHeader(isAuth);
    return this.http.put(this.layoutService.apiUrl + url, putValue, this.authHeaderOptions).pipe(
      map(res => { return res; }),
      //tap(res=>{ return res;}),
      catchError(err => { this.catchError(err); return of(err.message) })
    );
  }
}
